<template>
  <div class="relative w-full h-full overflow-y-auto p-4">
    <div class="bg-white rounded-lg p-6 mb-4">
      <h2 class="font-bold text-xl mb-4">CSV-Import</h2>
      <div class="mb-4">
        <label>Datentyp</label>
        <select v-model="kind" class="border-2 border-gray-200 px-2 py-1 w-full max-w-md">
          <option value="Kunden">Kunden</option>
          <option value="Kontakte">Kontakte</option>
          <option value="Mitarbeiter">Mitarbeiter</option>
        </select>
      </div>
      <div v-if="fields[kind]" class="mb-4">
        <h3 class="font-bold mb-2">Verfügbare Felder:</h3>
        <div class="flex flex-wrap gap-2">
          <span v-for="field in fields[kind]" :key="field" class="bg-gray-100 px-2 py-1 rounded text-sm">{{ field }}</span>
        </div>
      </div>
      <div class="mb-4">
        <label>Datei (CSV)</label>
        <input type="file" accept=".csv" @change="onFileChange" class="border-2 border-gray-200 px-2 py-1 w-full max-w-md">
      </div>
      <button @click="doImport" :disabled="!selectedFile || importing">
        {{ importing ? 'Importiere...' : 'Import starten' }}
      </button>
      <div v-if="result" class="mt-6">
        <div v-if="result.entries > 0" class="text-green-600 mb-2">
          {{ result.entries }} Datensätze erfolgreich importiert.
        </div>
        <div v-if="result.fieldErrors && result.fieldErrors.length > 0" class="text-red-600 mb-2">
          Unbekannte Felder: {{ result.fieldErrors.join(', ') }}
        </div>
        <div v-if="result.importErrors && result.importErrors.length > 0" class="text-red-600">
          <h4 class="font-bold">Fehler beim Import:</h4>
          <ul>
            <li v-for="(err, i) in result.importErrors" :key="i">Zeile {{ err.line }}: {{ err.error }}</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from "@/API";
export default {
  name: "CsvImport",
  props: ["user"],
  data() {
    return {
      kind: "Kunden",
      fields: {},
      selectedFile: null,
      importing: false,
      result: null,
    };
  },
  methods: {
    loadFields() {
      API.getImportFields((r) => { this.fields = r; });
    },
    onFileChange(e) {
      this.selectedFile = e.target.files[0];
    },
    doImport() {
      if (!this.selectedFile) return;
      this.importing = true;
      this.result = null;
      API.importCsv(this.selectedFile, this.kind, (r, status) => {
        this.importing = false;
        if (r) {
          this.result = r;
        } else {
          this.result = { entries: 0, fieldErrors: [], importErrors: [{ line: 0, error: "Import fehlgeschlagen (Status " + status + ")" }] };
        }
      });
    },
  },
  created() {
    this.loadFields();
  },
};
</script>

<style scoped>
label { display: block; font-weight: bold; margin-bottom: 4px; }
</style>
